module.exports = __webpack_public_path__ + "img/Prenatal Vitamin.7cf73524.jpg";